<app-navbar-style-two></app-navbar-style-two>

<!-- <app-posnavbar></app-posnavbar> -->
<!-- <div class="banner-area-two client-slider owl-carousel owl-theme">
    <div class="client-item">
        <img src="https://medeilpos.blob.core.windows.net/websiteimage/veterinarysoftwaremedeilcloudpos.png" alt="veterinary software medeilcloud pos">
        <div class="overlay-buttons row">
            <div class="col-lg-6">
                <button type="button" class="default-btn1">14 Days Free Trial</button>
            </div>
            <div class="col-lg-6">
                <button type="button" class="default-btn1" (click)="appointment('Veterinary Vertical')">Demo Request</button>
            </div>
        </div>
    </div>
</div> -->
<div class="slider-area owl-carousel owl-theme">
  <div class="slider-item item-bg-veterinary">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="container">
                  <div class="slider-content">
                      <h1 i18n>MEDEIL Veterinary Software – Smart Management for Animal Clinics</h1>
                      <!-- <h2 i18n>Track Medications, Manage Inventory, and Simplify Billing for Veterinary Stores</h2> -->
                          <button i18n type="button" class="default-btn" (click)="appointment('Veterinary vertical')">Get Started Now</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>


<br>
<div class="container-md p-5 box-container">
    <p i18n style="color:white">Take your veterinary practice to the next level with MEDEIL Veterinary Software. Designed for modern animal clinics and hospitals, MEDEIL empowers your team to deliver exceptional care, streamline daily operations, and grow your practice with confidence.</p>
</div>
<br>



<ngx-smart-modal #enquirypos identifier="enquirypos" [closable]="false">


  <div class="custom-modal">
     <button class="close-btn" (click)="closeModal()">X</button>
     <div class="modal-header">
         <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
     </div>
       <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
             <!-- <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="countryname1"> -->
             <select class="form-control"  formControlName="countryname1" style="font-size: 12px;" (change)="countrychange()">
              <!-- (change)="countrychange()" -->
              <option i18n select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

            </select>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <!-- <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Enter captcha</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name">
           </div> -->
           <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">

                 <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div class="btn-group mt-3" *ngIf="!showElement">
             <button i18n type="button" class="enquiry-btn" (click)="submitenquery()" >Submit</button>

           </div>


         </form>
       </div>
 </div>
</ngx-smart-modal>
<ngx-smart-modal #appointmentform identifier="appointmentform" [closable]="false">


  <div class="custom-modal"  >
     <button class="close-btn" (click)="closeModal()">X</button>
      <div class="modal-header-appointment">
          <h4 i18n class="modal-title" id="exampleModalLabel">Demo Request</h4>
      </div>
        <div class="modal-body">

           <div class="row">
              <div class="col-lg-12">
                 <mat-form-field >

                    <input matInput [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="slectdate($event)" >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                 </mat-form-field>

              </div>
              <div  align="center" *ngIf="showElement">
                 <img height="200px" width="200px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
               </div>
              <div class="col-lg-12" *ngIf="appointment_time">

                  <div class="button-container">
                    <button class="flex-button" *ngFor="let time of timeSlots" (click)="selectTime(time)" [ngClass]="{ 'clicked': selectedTime === time }">{{ time }}</button>
                </div>
                <div  align="center" *ngIf="showElementsave">
                  <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
                </div>
                  <div class="shedule-submit">
                    <button i18n class="shedulebtn" (click)="savelead()">Submit</button>
                  </div>
              </div>
           </div>

        </div>
  </div>
</ngx-smart-modal>
<div class="newslider" >

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/anu-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/apollo-hospitals.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bellamed-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bk-heart-hospital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/booncholai-super-market.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/emedsure.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/express-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/falcon-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/global-bridge-pharmaceutical.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hawi-family-hostpital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/henry-jackson-foundation.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/imcri.webp" alt="image" height="200" width="300" priority>
  </div>

</div>
<!-- <div class="section-title container gradient-text mb-2" >

    <h2>Features</h2>
</div> -->
<!-- ---------------------------- -->


<div id="services" class="services section">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
            <div i18n class="gradient-text"><h2>Veterinary Store Software | Efficient Management for Veterinary Retail</h2>for you</div>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
           <p i18n>Running a veterinary store comes with its own set of challenges. From managing pet medications and food supplies to tracking prescriptions and ensuring compliance, the workload can be overwhelming. That’s where Medeil’s Veterinary Store Software steps in – a smart, all-in-one solution designed to simplify your operations and help your business thrive.</p>
          </div>
        </div>
      </div>
    </div>


<section class="info-section">
    <div class="container2">
        <div class="text-content">
            <h2 i18n class="title">Effortless Appointment Scheduling and Patient Management</h2>
            <p i18n class="description">
             Never miss a patient or double-book an appointment again. MEDEIL’s intuitive scheduling system lets you manage appointments, track patient visits, and coordinate staff calendars with ease. Automated reminders and digital patient records ensure every animal receives timely, personalized care.            </p>
        </div>
    </div>
</section>



    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="service-item first-service">
            <div class="icon"></div>
            <h4 i18n>Save Time and Reduce Errors</h4>
            <p i18n> Automate repetitive tasks like inventory tracking and billing, so you can focus on serving your customers.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item second-service">
            <div class="icon"></div>
            <h4 i18n>Improve Customer Experience</h4>
            <p i18n>Provide faster, more personalized service with features like prescription management and CRM.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item third-service">
            <div class="icon"></div>
            <h4 i18n>Optimize Inventory</h4>
           <p i18n>
            Avoid overstocking or running out of essential items with real-time inventory tracking and alerts.
           </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item fourth-service">
            <div class="icon"></div>
            <h4 i18n>Boost Profitability</h4>
            <p i18n style="line-height: 1.3;">
              Use sales insights to identify trends, plan promotions, and increase revenue.
            </p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- ---------------------------- -->


<!-- start of key feature-->
<section class="about section-padding" id="features">
    <div class="section-title gradient-text ">
        <h2 i18n style="text-align: center;">Key Features for Veterinary Practice Success</h2>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-10 col-12 ms-lg-auto mb-2 mb-lg-0">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button i18n class="nav-link active" id="nav-intro-tab" data-bs-toggle="tab" data-bs-target="#nav-intro" type="button" role="tab" aria-controls="nav-intro" aria-selected="true">Comprehensive Patient Records</button>
                        <button i18n class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Integrated Appointment Calendar</button>
                        <button i18n class="nav-link" id="nav-faq-tab" data-bs-toggle="tab" data-bs-target="#nav-faq" type="button" role="tab" aria-controls="nav-faq" aria-selected="false">Customizable Workflows</button>
                        <button i18n class="nav-link" id="nav-faq-data" data-bs-toggle="tab" data-bs-target="#nav-data" type="button" role="tab" aria-controls="nav-data" aria-selected="false">Staff Management Tools</button>
                    </div>
                </nav>
            </div>
            <div class="col-12">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-intro" role="tabpanel" aria-labelledby="nav-intro-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/opticalchainstoresoftware - medeilcloud hq.png" class="img-fluid" alt="optical chain store software - medeilcloud hq" height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Comprehensive Patient Records</h3>
                                  <p i18n>Store medical histories, vaccination schedules, and treatment plans for every animal.</p>
                                    <!-- <p i18n>Administrators should be able to monitor and manage all pharmacy locations' activities from a single dashboard thanks to the software's centralized management features.</p> -->
                                    <!-- <p i18n>Managing user access, pricing, promotions, and inventory are all included in this.</p> -->
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <div class="row">
                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Integrated Appointment Calendar</h3>
                              <!-- <p i18n>In order to allow each pharmacy to function independently and to enable centralized management and communication between stores, the software should handle several pharmacy locations. </p> -->
                              <p i18n>Book, reschedule, and manage appointments in real time.</p>
                            </div>

                            <div class="col-lg-6 col-12 mt-lg-0 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloud hq.png" class="img-fluid" alt="medical device software for chainstores medeilcloud hq"  height="400" width="500" priority>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade mb-4" id="nav-faq" role="tabpanel" aria-labelledby="nav-faq-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/multi store software = medeilcloud hq.png" class="img-fluid" alt="multi store software medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Customizable Workflows</h3>

                              <!-- <p i18n>The software must give top priority to safeguarding patient information and adhering to HIPAA (Health Insurance Portability and Accountability Act) and other healthcare standards, such as WHO-DDD, WHO-ATC Coding, and WHO-ICD Standards.</p> -->
                              <p i18n>Adapt the software to your clinic’s unique processes and specialties.</p>


                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade mb-4" id="nav-data" role="tabpanel" aria-labelledby="nav-faq-data">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/chainsoftware-medeilcloud hq.png" class="img-fluid" alt="chain software-medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Staff Performance Tools</h3>

                             <p i18n>
                               Track performance, assign tasks, and monitor productivity.</p>
                                <!-- <p i18n>This features support for upcoming expansions, modifiable processes, and adjustable settings.</p> -->
                            </div>
                         </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div id="faq"></div>
</section>
<!-- end of key feature -->

<!-- inventory and billing  -->
<br>
<section class="benefits-section box-container">
    <div class="benefits-container">
        <div class="benefits-grid">
            <div class="benefit-card1">
                <h4 i18n>Inventory and Billing Made Simple</h4>
                <p i18n>Stay on top of your clinic’s supplies and finances. MEDEIL offers real-time inventory tracking, low-stock alerts, and automated reordering to ensure you never run out of critical items. Integrated billing and invoicing make payment processing fast and accurate, reducing administrative workload and improving cash flow.</p>
            </div>
            <div class="benefit-card1">
                <h4 i18n>How to Get Started with MEDEIL Veterinary Software</h4>
                <p i18n>Getting started is simple. Our onboarding specialists guide you through setup, data migration, and staff training, ensuring a smooth transition from your current system. With user-friendly interfaces and ongoing support, your team will be up and running in no time.</p>
            </div>
            <div class="benefit-card1">
                <h4 i18n>Trusted by Veterinary Clinics and Animal Hospitals</h4>
                <p i18n>Join a growing community of veterinary professionals who trust MEDEIL to power their clinics. From small animal practices to large hospitals, MEDEIL delivers reliability, security, and the flexibility to grow with your business.</p>
            </div>
        </div>
    </div>
</section>
<br>
<!-- end of inventory and billing  -->


<!-- about  -->
<div id="about" class="about-us section">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 align-self-center">
        <div class="section-heading">
          <h4 i18n>About what we do</h4>
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
         <p i18n>
            We concentrate on creating cutting-edge software solutions that are customized to meet the particular requirements of hospitals, veterinary clinics, and pet care facilities. Our mission is to provide vets and other pet care providers with state-of-the-art tools that optimize workflows, improve patient outcomes, and boost overall productivity.
         </p>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="box-item" routerLink="/medeil">
                  <h5 i18n><a >Standalone Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/medeilcloudpos">
                  <h5 i18n><a >SaaS Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/medeilcloudhq">
                  <h5 i18n><a >Chain Store Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/allotmed">
                  <h5 i18n><a >Distribution Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-12 text-center">
                <div class="box-item" routerLink="/hosbay-healthcare">
                  <h5 i18n><a >Hospital Inventory Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
          <div class="col-lg-12">
            <p i18n>
                At Vanuston, we are more than just a provider of veterinary goods and services—we are a dependable resource and partner that supports veterinary practices and companies in providing the best possible care to their patients and clients.
            </p>
            <div>
             <!-- <button class="gradient-button">Start Free Trial</button> -->
            </div>
            <!-- <span>*No Credit Card Required</span> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="right-image">
          <img src="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloudpos.gif" alt="medical pos billing- medeilcloud pos" loading="lazy">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- ---- -->
<section class="vet-benefits-section">
  <div class="vet-container">
      <h2 i18n class="vet-title">Who Can Benefit from Medeil’s Veterinary Store Software?</h2>
      <p i18n class="vet-description">
          Our software helps veterinary stores and pet clinics manage inventory, sales, and operations efficiently.
      </p>

      <div class="vet-cards">
          <div class="vet-card">
              <div class="vet-icon"><i class="fas fa-clinic-medical"></i></div>
              <h3 i18n>Independent Veterinary Stores</h3>
              <p i18n>Upgrade your veterinary store with modern tools for efficient inventory and sales management.</p>
          </div>

          <div class="vet-card">
              <div class="vet-icon"><i class="fas fa-warehouse"></i></div>
              <h3 i18n>Chain Veterinary Stores</h3>
              <p i18n>Centralized management and automation for multiple veterinary store locations.</p>
          </div>

          <div class="vet-card">
              <div class="vet-icon"><i class="fas fa-paw"></i></div>
              <h3 i18n>Pet Clinics with Retail</h3>
              <p i18n>Ideal for pet clinics selling medications, pet food, and accessories.</p>
          </div>
      </div>
  </div>
</section>
<div class="container mt-4">
    <div class="section-title gradient-text mt-2 mb-2" >

        <h2 i18n>Frequently Asked Questions</h2>
    </div>
    <div class="row pt-4">
        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Which kinds of drugs and supplies do you provide for animals?</h4>
                <p i18n><strong>A:</strong> Consumers frequently inquire about the variety of drugs and supplies that are offered for different kinds of animals, such as over-the-counter vitamins, prescription drugs, vaccinations, and specialized goods like veterinary diets and compounded drugs.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: How can your Veterinary software improve clinic operations efficiency?</h4>
                <p i18n><strong>A:</strong> This inquiry pertains to the MEDEILCloud POS & HQ software's advantages in terms of productivity and efficiency. Features like inventory tracking, appointment scheduling, electronic health record management, and automated billing procedures that save administrative work and boost workflow efficiency could be among the solutions.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Can your software be tailored to meet the unique requirements of our Pet pharmacy & clinic?</h4>
                <p i18n><strong>A:</strong> This inquiry looks for details regarding the software's versatility and customization options. Information on user interfaces, workflow configurations, and templates that can be customized to a clinic's specific needs and preferences may be included in the answers.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: What type of assistance and training are available for setting up and utilising the software? </h4>
                <p i18n><strong>A:</strong> This inquiry relates to the software vendor's support and training offerings. In addition to providing clinics with access to instructional materials, webinars, and individualized support from a dedicated support team, the answers should outline the training resources, onboarding aid, and continuing support choices available to assist clinics in successfully implementing and using the software.</p>
            </div>
        </div>
    </div>


</div>
<div class="row mb-3 mt-3" style="width: 100%;">
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Crowd Review</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.3/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Google</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.8/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Capterra</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.4/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Software Suggest</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.7/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>G2 Crowd</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.1/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Trust Radius</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.6/5.0</p>
        </div>
  </div>
</div>


<br>
<div class="container-md p-5 box-container">
  <h3 i18n style="color: white;">Call to Action</h3>
  <p i18n style="color:white">Ready to transform your veterinary practice? Request a free demo of MEDEIL Veterinary Software and discover how our solution can simplify your clinic’s management and enhance patient care.</p>
  <a i18n (click)="appointment('veterinary Demo')" class="cta-button">🚀 Request a Free Demo</a>
  </div>
<br>

<app-footer-style-two></app-footer-style-two>
